module.exports = __webpack_public_path__ + "static/hero-5c99ac8966c333707e29225d63639bc7.png";